import { render, staticRenderFns } from "./activityCategoryGoodsItem.vue?vue&type=template&id=0722da43&scoped=true"
import script from "./activityCategoryGoodsItem.vue?vue&type=script&lang=js"
export * from "./activityCategoryGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./activityCategoryGoodsItem.vue?vue&type=style&index=0&id=0722da43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722da43",
  null
  
)

export default component.exports